export default __webpack_public_path__ + "static/media/pile 4 1.62341a87.png";